import React, { useEffect, useState } from 'react';
const POINT_KEY = 'cncPointId';
const POINT_NAME_KEY = 'cncPointName';

export function getSelectedPointId() {
  return sessionStorage.getItem(POINT_KEY);
}

export function getSelectedPointName() {
  return sessionStorage.getItem(POINT_NAME_KEY) || '';
}

export function clearSelectedPoint() {
  sessionStorage.removeItem(POINT_KEY);
  sessionStorage.removeItem(POINT_NAME_KEY);
}

export default function PointSelector() {
  const [points, setPoints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch('/api/points')
      .then((r) => r.json())
      .then((data) => {
        setPoints(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => {
        setError('Не удалось загрузить список точек. Проверьте сервер.');
        setLoading(false);
      });
  }, []);

  const selectPoint = (point) => {
    sessionStorage.setItem(POINT_KEY, point.id);
    sessionStorage.setItem(POINT_NAME_KEY, point.name);
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-100 dark:bg-neutral-900 p-4">
      <div className="w-full max-w-lg bg-white dark:bg-neutral-800 rounded-2xl shadow-xl border border-neutral-200 dark:border-neutral-700 p-8">
        <h1 className="text-2xl font-semibold text-center mb-2 text-neutral-800 dark:text-white">
          С&amp;С Sales
        </h1>
        <p className="text-center text-neutral-500 dark:text-neutral-400 mb-8">
          Выберите точку для работы
        </p>

        {loading && <p className="text-center text-neutral-500">Загрузка…</p>}
        {error && <p className="text-center text-red-500 mb-4">{error}</p>}

        {!loading && !error && points.length === 0 && (
          <p className="text-center text-neutral-500 mb-4">
            Нет доступных точек. Создайте их на cncstat.дсдтан.рф
          </p>
        )}

        <div className="space-y-3">
          {points.map((point) => (
            <button
              key={point.id}
              type="button"
              onClick={() => selectPoint(point)}
              className="w-full text-left px-4 py-4 rounded-xl border border-neutral-200 dark:border-neutral-600 bg-white text-neutral-900 hover:border-blue-500 hover:bg-blue-50 transition-colors"
            >
              <div className="font-medium">{point.name}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
